require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_core-js@2.6.2@core-js/library/modules/es7.symbol.observable.js
// module id = 472
// module chunks = 0